export const DOWNLOAD_QR_CODE = '/api/v1/download';
export const FETCH_METADATA = '/api/v1/fetch-site-metadata';
export const FETCH_OPTIONS = '/api/v1/qr-type';
export const QR = '/api/v1/qr';
export const FORMSTACK = '/api/v1/feedback';
export const FETCH_SHAPES = '/api/v1/shapes';
export const UPDATE_USER = '/api/v2/user';
export const FREE_ACCOUNT = '/api/v1/freeAccount';
export const UPLOAD_LOGO = '/api/v1/logo';
